import API from '@/api';
import moment from 'moment';
import * as types from '@/store/mutationTypes';

const state = {
  companyId: null,
  list: [],
  loadingBids: false,
  timestamp: null,
};

const getters = {
  bids: bidsState => bidsState.list,
  companyId: bidsState => bidsState.companyId,
  timestamp: bidsState => bidsState.timestamp,
  loadingBids: bidsState => bidsState.loadingBids,
};

const mutations = {
  [types.SET_BIDS](loadState, { items, companyId, loading }) {
    loadState.list = items || []; // eslint-disable-line no-param-reassign

    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingBids = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
};

const actions = {
  async getBids({ commit, dispatch }, companyId) {
    try {
      commit(types.SET_BIDS, { items: null, companyId, loading: true });
      const response = await API.company.getBids(companyId);
      commit(types.SET_BIDS, { items: response.data.items, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: 'An error occurred, please try again later',
      }, { root: true });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/bids.js